import { render } from "./Dashboard.vue?vue&type=template&id=00786831&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=00786831&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00786831"

export default script